import React from 'react';

import LinkOffIcon from '@mui/icons-material/LinkOff';
import { Box, Paper, Stack, Typography } from '@mui/material';

import { formatDealOptionName } from '../../shared/format';

import type { UnlinkedDealOptionView } from './types';

interface Props {
  dealOptions: Array<UnlinkedDealOptionView>;
}

export default function UnlinkedDealOptionsCard({ dealOptions }: Props) {
  if (dealOptions.length === 0) {
    return null;
  }

  return (
    <Paper variant="outlined" sx={{ borderRadius: 1.25, overflow: 'hidden' }}>
      <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ p: 2 }}>
        <Box sx={{ color: 'text.disabled', display: 'flex', pt: 0.25 }}>
          <LinkOffIcon fontSize="small" />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700}>
            Unlinked deal options ({dealOptions.length})
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Room checks can&apos;t run for these deal options until a room asset is linked in Salesforce.
          </Typography>
        </Box>
      </Stack>
      {dealOptions.map((dealOption) => (
        <Box key={dealOption.dealId} sx={{ borderTop: 1, borderColor: 'divider', px: 2, py: 1.25 }}>
          <Typography variant="body2" fontWeight={600}>
            {formatDealOptionName(dealOption.dealOptionName)}
          </Typography>
        </Box>
      ))}
    </Paper>
  );
}
